var _circle, _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgLinkIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 16,
    cy: 16,
    r: 16,
    fill: "#FFCE7A"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M14.6332 20.1953L12.7477 22.0806C11.9661 22.8622 10.7003 22.8622 9.91927 22.0808C9.13812 21.2997 9.13812 20.0338 9.91912 19.2529L13.6906 15.4817C14.4716 14.7007 15.7375 14.7007 16.5185 15.4817C16.7789 15.742 17.201 15.742 17.4614 15.4817C17.7217 15.2214 17.7217 14.7993 17.4614 14.5389C16.1597 13.2373 14.0495 13.2373 12.7477 14.5389L8.9763 18.3101C7.67457 19.6117 7.67457 21.7217 8.9763 23.0233C10.2779 24.3257 12.3882 24.3257 13.6906 23.0233L15.576 21.1381C15.8364 20.8777 15.8364 20.4556 15.576 20.1953C15.3157 19.935 14.8935 19.935 14.6332 20.1953Z",
    fill: "white"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M23.0237 8.97622C21.722 7.67459 19.6111 7.67459 18.3094 8.97622L16.0473 11.2381C15.7869 11.4985 15.7869 11.9206 16.0473 12.1809C16.3076 12.4412 16.7298 12.4412 16.9901 12.1809L19.2522 9.91899C20.0332 9.13803 21.2998 9.13803 22.0809 9.91899C22.8618 10.6999 22.8618 11.9658 22.0809 12.7467L17.9327 16.8946C17.1517 17.6755 15.8858 17.6755 15.1048 16.8946C14.8444 16.6342 14.4223 16.6342 14.1619 16.8946C13.9016 17.1549 13.9016 17.577 14.1619 17.8373C15.4636 19.139 17.5738 19.139 18.8755 17.8373L23.0237 13.6895C24.3254 12.3879 24.3254 10.2779 23.0237 8.97622Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLinkIcon);
export default __webpack_public_path__ + "static/media/linkIcon.679671c2a37ca51bfe48924e27ff63c2.svg";
export { ForwardRef as ReactComponent };